"use client";

import { c as _c } from "react/compiler-runtime";
import { Link } from "@/navigation";
import { useLocale, useTranslations } from "next-intl";
import { getSocialProfiles } from "@/lib/social-profiles";
interface FooterProps {
  /** Links to the guides and the comparison. Off on guest upload pages. */
  hasSiteLinks?: boolean;
}
export default function Footer(t0) {
  const $ = _c(40);
  const {
    hasSiteLinks: t1
  } = t0;
  const hasSiteLinks = t1 === undefined ? false : t1;
  const t = useTranslations("Footer");
  const t2 = useLocale();
  let t3;
  if ($[0] !== t2) {
    t3 = getSocialProfiles(t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const socialProfiles = t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <hr className="" />;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = new Date().getFullYear();
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== t) {
    t6 = t("allRightsReserved");
    $[4] = t;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t6) {
    t7 = <p>© {t5} Guest.Gallery, {t6}</p>;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== hasSiteLinks || $[9] !== t) {
    t8 = hasSiteLinks ? <><Link className="underline" href="/blog">{t("guides")}</Link><Link className="underline" href="/sammenligning">{t("comparison")}</Link></> : null;
    $[8] = hasSiteLinks;
    $[9] = t;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t) {
    t9 = t("privacyPolicy");
    $[11] = t;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t9) {
    t10 = <Link className="underline" href="/privacy-policy">{t9}</Link>;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t) {
    t11 = t("termsAndConditions");
    $[15] = t;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t11) {
    t12 = <Link className="underline" href="/terms-and-conditions">{t11}</Link>;
    $[17] = t11;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <a className="underline" href="https://replysky.com" target="_blank" rel="noreferrer">Replysky</a>;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== socialProfiles.instagram) {
    t14 = <a className="underline" href={socialProfiles.instagram} target="_blank" rel="noopener noreferrer">Instagram</a>;
    $[20] = socialProfiles.instagram;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== socialProfiles.facebook) {
    t15 = <a className="underline" href={socialProfiles.facebook} target="_blank" rel="noopener noreferrer">Facebook</a>;
    $[22] = socialProfiles.facebook;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== t10 || $[25] !== t12 || $[26] !== t14 || $[27] !== t15 || $[28] !== t8) {
    t16 = <div className="flex flex-col md:flex-row gap-4">{t8}{t10}{t12}{t13}{t14}{t15}</div>;
    $[24] = t10;
    $[25] = t12;
    $[26] = t14;
    $[27] = t15;
    $[28] = t8;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== t16 || $[31] !== t7) {
    t17 = <div className="p-4  flex flex-col gap-8 mx-auto">{t4}<div className="flex justify-between gap-4 flex-wrap">{t7}{t16}</div></div>;
    $[30] = t16;
    $[31] = t7;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== t) {
    t18 = t("companyLine");
    $[33] = t;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== t18) {
    t19 = <div className="mx-4 text-sm text-gray-500">{t18}</div>;
    $[35] = t18;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] !== t17 || $[38] !== t19) {
    t20 = <div className=" w-full  py-8">{t17}{t19}</div>;
    $[37] = t17;
    $[38] = t19;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  return t20;
}